import React, { useCallback, useMemo, useState } from 'react'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'
import styled from 'styled-components'

import { MyModal } from '~/components/ui/MyModal'
import { MyBtn } from '~/components/ui/MyBtn'

import { QRLogin } from './QRLogin'
import { CodeLogin } from './CodeLogin'
import { PwdLogin } from './PwdLogin'

const LinkText = styled(MyBtn)`
  display: block;
  margin: 0 auto;
`

type LoginType = 'pwd' | 'code' | 'qr'
interface LoginTypes {
  type: LoginType
  label: string
  title: string
}

const loginTypes: LoginTypes[] = [
  { type: 'pwd', label: '账号密码登录', title: '账号密码登录' },
  { type: 'code', label: '验证码登录/注册', title: '手机快捷登录/注册' },
  { type: 'qr', label: '扫码登录', title: '扫码登录' },
]

export const LoginModal: React.FC = observer(() => {
  const [loginType, setLoginType] = useState<LoginType>('code')
  const { store } = useStores()

  const visible = useMemo(() => {
    return !!store.modal?.login
  }, [store.modal])

  const setVisible = useCallback(
    (visible: boolean) => {
      store.modal?.setLoginVisible(visible)
    },
    [store.modal]
  )

  return (
    <>
      <MyModal
        open={visible}
        title={loginTypes.find(item => item.type === loginType)?.label}
        onCancel={() => setVisible(false)}
        maskStyle={{
          backgroundColor: 'rgba(0,0,0,0.8)',
        }}
        width={448}
        footer={null}
        dark
      >
        {loginType === 'qr' && <QRLogin setVisible={setVisible} />}
        {loginType === 'code' && <CodeLogin setVisible={setVisible} />}
        {loginType === 'pwd' && <PwdLogin setVisible={setVisible} />}

        <div className="flex items-center">
          {loginTypes
            .filter(item => item.type !== loginType)
            .map(item => {
              return (
                <LinkText
                  key={item.type}
                  onClick={() => setLoginType(item.type as any)}
                  type="link"
                >
                  {item.label}
                </LinkText>
              )
            })}
        </div>
      </MyModal>
    </>
  )
})
